import React from 'react';
import { motion } from 'framer-motion';
import { PORTFOLIO_DATA } from '../data/portfolio';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import SafeIcon from '../common/SafeIcon';
import { FiExternalLink, FiGithub } from 'react-icons/fi';

export const Projects = () => {
  const { projects } = PORTFOLIO_DATA;

  return (
    <div className="space-y-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">All Projects</h1>
        <p className="text-xl text-slate-400 max-w-2xl">
          A collection of tools, platforms, and experiments aimed at supercharging the solo developer experience.
        </p>
      </motion.div>

      <div className="space-y-8">
        {projects.map((project, index) => (
          <motion.div
            key={project.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <Card className="flex flex-col md:flex-row gap-8 items-start">
              <div className="flex-grow">
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-2xl font-bold text-white">{project.title}</h2>
                  <div className="flex space-x-3">
                    <a href="#" className="text-slate-400 hover:text-indigo-400 transition-colors">
                      <SafeIcon icon={FiGithub} className="h-5 w-5" />
                    </a>
                    <a href="#" className="text-slate-400 hover:text-indigo-400 transition-colors">
                      <SafeIcon icon={FiExternalLink} className="h-5 w-5" />
                    </a>
                  </div>
                </div>
                
                <p className="text-lg text-indigo-300 font-medium mb-4">
                  {project.description}
                </p>
                
                <p className="text-slate-400 leading-relaxed mb-6">
                  {project.longDescription}
                </p>
                
                <div className="flex flex-wrap gap-2">
                  {project.tags.map(tag => (
                    <Badge key={tag}>{tag}</Badge>
                  ))}
                </div>
              </div>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  );
};